import { createContext } from 'react';

const PseStrategyContext = createContext({});

export default PseStrategyContext;
